import React from 'react';
import Button, { ButtonModeE } from '../../components/Button/Button';
import usePopup from '../../utils/hooks/usePopup';

import styles from './unsavedChangesWarning.module.scss';

const UnsavedChangesWarningFooter = () => {
    const { removePopup, removeAllPopups } = usePopup();

    const handleYes = () => {
        removeAllPopups();
    };

    const handleNo = () => {
        removePopup();
    };

    return (
        <div className={styles.footer}>
            <Button onClick={handleYes}>Yes, cancel</Button>
            <Button mode={ButtonModeE.OUTLINED} onClick={handleNo}>No, keep editing</Button>
        </div>
    );
};

export default UnsavedChangesWarningFooter;